import * as React from "react";
import { memo } from "react";
const SvgPopUpTopBar = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 382, height: 56, viewBox: "0 0 382 56", fill: "none", className: "w-full h-auto", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M358 0H0V56H382V24L358 0Z", fill: "#689962" }));
const Memo = memo(SvgPopUpTopBar);
export default Memo;
